(ns cloudpermit-commons.schemas.general
  (:require [clojure.string :as str]
            [schema-tools.openapi.core]
            [schema-tools.swagger.core]
            [schema.core :as s]))

(def not-blank? (complement str/blank?))

(def NonBlankString (s/pred not-blank? 'string-cannot-be-blank))

(defmethod schema-tools.swagger.core/transform-pred not-blank? [_ _] {:type "string"})

(defmethod schema-tools.openapi.core/transform-pred not-blank? [_ _] {:type "string"})
